import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

export const usePermissions = (controller?: string) => {
  const permissionList = useSelector((state: any) => state.permissions);

  const controllerActions: string[] = useMemo(() => {
    if (controller) {
      return permissionList[controller] || [];
    }

    return [];
  }, [controller, permissionList]);

  const hasAccess = useCallback(
    (controller: string, access: string): boolean => {
      const accesses: string[] = permissionList[controller];

      return accesses ? accesses.includes(access) : false;
    },
    [permissionList]
  );

  const hasAccessByController = useCallback(
    (access: string): boolean => {
      return controllerActions.includes(access);
    },
    [controllerActions]
  );

  return { hasAccess, hasAccessByController };
};
